import React from 'react';

export const LeftArrowRounded = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5803 19.3896C15.8731 19.6825 15.8731 20.1572 15.5803 20.4501C15.2874 20.743 14.8126 20.743 14.5197 20.4501L7.9992 13.9306C6.93641 12.8677 6.93636 11.1321 7.9992 10.0693L14.5197 3.54975C14.8126 3.25686 15.2874 3.25686 15.5803 3.54975C15.8732 3.84264 15.8732 4.3174 15.5803 4.6103L9.06073 11.1308C8.58364 11.6079 8.58363 12.393 9.06073 12.8701L15.5803 19.3896Z"
      fill="#64748B"
    />
  </svg>
);
